import PropTypes from 'prop-types';

import { FormHelp, Text } from '@zillow/constellation-10';

const propTypes = {
  description: PropTypes.string,
};

const defaultProps = {
  description: '',
};

const getStrengthLevel = (length) => {
  if (length <= 300) return 'weak';
  if (length > 600 && length <= 900) return 'strong';
  return 'good'; // 301-600 or 900+
};

const PropertyDescriptionStrength = ({ description }) => {
  const strengthLevel = getStrengthLevel(description.length);

  return (
    <FormHelp role="status" aria-live="polite">
      Description strength:&nbsp;
      {strengthLevel === 'weak' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.critical.strong' }}>
          Weak
        </Text>
      )}
      {strengthLevel === 'good' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.warning.strong' }}>
          Good
        </Text>
      )}
      {strengthLevel === 'strong' && (
        <Text textStyle="body-xs-bold" css={{ color: 'text.feedback.success.strong' }}>
          Strong
        </Text>
      )}
    </FormHelp>
  );
};

PropertyDescriptionStrength.propTypes = propTypes;
PropertyDescriptionStrength.defaultProps = defaultProps;

export default PropertyDescriptionStrength;
